"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.tezosBuildTransaction = void 0;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var isValidRecipient_1 = require("../../libcore/isValidRecipient");
var buildBigNumber_1 = require("../../libcore/buildBigNumber");
var types_1 = require("./types");
var modulo_1 = require("../../modulo");
function tezosBuildTransaction(_a) {
    var account = _a.account, core = _a.core, coreAccount = _a.coreAccount, coreCurrency = _a.coreCurrency, transaction = _a.transaction, isCancelled = _a.isCancelled;
    return __awaiter(this, void 0, void 0, function () {
        var currency, recipient, fees, gasLimit, storageLimit, subAccountId, subAccount, tezosAccount, tezosLikeAccount, accounts, accounts_1, accounts_1_1, a, addr, e_1_1, feesAmount, gasLimitRounded, gasLimitAmount, storageBigInt, transactionBuilder, type, amount, builded;
        var e_1, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    currency = account.currency;
                    recipient = transaction.recipient, fees = transaction.fees, gasLimit = transaction.gasLimit, storageLimit = transaction.storageLimit, subAccountId = transaction.subAccountId;
                    subAccount = subAccountId
                        ? account.subAccounts &&
                            account.subAccounts.find(function (t) { return t.id === subAccountId; })
                        : null;
                    return [4 /*yield*/, coreAccount.asTezosLikeAccount()];
                case 1:
                    tezosLikeAccount = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    if (!(subAccount && subAccount.type === "ChildAccount")) return [3 /*break*/, 11];
                    return [4 /*yield*/, tezosLikeAccount.getOriginatedAccounts()];
                case 2:
                    accounts = _c.sent();
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 8, 9, 10]);
                    accounts_1 = __values(accounts), accounts_1_1 = accounts_1.next();
                    _c.label = 4;
                case 4:
                    if (!!accounts_1_1.done) return [3 /*break*/, 7];
                    a = accounts_1_1.value;
                    return [4 /*yield*/, a.getAddress()];
                case 5:
                    addr = _c.sent();
                    if (addr === subAccount.address) {
                        tezosAccount = a;
                        return [3 /*break*/, 7];
                    }
                    _c.label = 6;
                case 6:
                    accounts_1_1 = accounts_1.next();
                    return [3 /*break*/, 4];
                case 7: return [3 /*break*/, 10];
                case 8:
                    e_1_1 = _c.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 10];
                case 9:
                    try {
                        if (accounts_1_1 && !accounts_1_1.done && (_b = accounts_1["return"])) _b.call(accounts_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 10:
                    (0, invariant_1["default"])(tezosAccount, "sub account not found " + subAccount.id);
                    return [3 /*break*/, 12];
                case 11:
                    tezosAccount = tezosLikeAccount;
                    _c.label = 12;
                case 12:
                    if (!(transaction.mode !== "undelegate")) return [3 /*break*/, 14];
                    return [4 /*yield*/, (0, isValidRecipient_1.isValidRecipient)({
                            currency: currency,
                            recipient: recipient
                        })];
                case 13:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    _c.label = 14;
                case 14:
                    if (!fees || !gasLimit || !storageLimit) {
                        throw new errors_1.FeeNotLoaded();
                    }
                    return [4 /*yield*/, (0, buildBigNumber_1.bigNumberToLibcoreAmount)(core, coreCurrency, fees)];
                case 15:
                    feesAmount = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    gasLimitRounded = gasLimit;
                    if (["delegate", "undelegate"].includes(transaction.mode)) {
                        gasLimitRounded = (0, modulo_1.upperModulo)(gasLimit, new bignumber_js_1.BigNumber(136), new bignumber_js_1.BigNumber(1000));
                    }
                    return [4 /*yield*/, (0, buildBigNumber_1.bigNumberToLibcoreAmount)(core, coreCurrency, gasLimitRounded)];
                case 16:
                    gasLimitAmount = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, buildBigNumber_1.bigNumberToLibcoreBigInt)(core, storageLimit)];
                case 17:
                    storageBigInt = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, tezosAccount.buildTransaction()];
                case 18:
                    transactionBuilder = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    switch (transaction.mode) {
                        case "send":
                            type = types_1.tezosOperationTag.OPERATION_TAG_TRANSACTION;
                            break;
                        case "delegate":
                        case "undelegate":
                            (0, invariant_1["default"])(!transaction.useAllAmount, "send max can't be used in delegation context");
                            (0, invariant_1["default"])(transaction.amount.isZero(), "amount must be ZERO in delegation context");
                            type = types_1.tezosOperationTag.OPERATION_TAG_DELEGATION;
                            break;
                        default:
                            throw new Error("Unsupported transaction.mode = " + transaction.mode);
                    }
                    return [4 /*yield*/, transactionBuilder.setType(type)];
                case 19:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    if (!transaction.useAllAmount) return [3 /*break*/, 21];
                    return [4 /*yield*/, transactionBuilder.wipeToAddress(recipient)];
                case 20:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [3 /*break*/, 24];
                case 21:
                    if (!transaction.amount)
                        throw new Error("amount is missing");
                    return [4 /*yield*/, (0, buildBigNumber_1.bigNumberToLibcoreAmount)(core, coreCurrency, new bignumber_js_1.BigNumber(transaction.amount))];
                case 22:
                    amount = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, transactionBuilder.sendToAddress(amount, recipient)];
                case 23:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    _c.label = 24;
                case 24: return [4 /*yield*/, transactionBuilder.setGasLimit(gasLimitAmount)];
                case 25:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, transactionBuilder.setFees(feesAmount)];
                case 26:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, transactionBuilder.setStorageLimit(storageBigInt)];
                case 27:
                    _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, transactionBuilder.build()];
                case 28:
                    builded = _c.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [2 /*return*/, builded];
            }
        });
    });
}
exports.tezosBuildTransaction = tezosBuildTransaction;
exports["default"] = tezosBuildTransaction;
//# sourceMappingURL=libcore-buildTransaction.js.map